export default __webpack_public_path__ + "static/media/blueBanner.070f2158.jpg";